module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-08.4b530fa1.jpg";